module.exports = __webpack_public_path__ + "img/lightmode_parallel.92580a23.png";